<template>
  <Layout>
    <PageHeader :title="title" :items="items"></PageHeader>
    <div class="row" id="promotion">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center mb-4">
              <div class="col-md-6">
                <div class="form-inline navbar-search">
                  <div class="input-group">
                    <input name="title" class="form-control bg-light border-0 small" placeholder="Search..."
                      aria-label="Search" aria-describedby="basic-addon2" value="" v-model="filter"
                      v-on:keyup="search" />
                    <div class="input-group-append">
                      <button class="btn btn-search" @click="searchFor">
                        <i class="fas fa-search fa-sm"> </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="all-tabs">
                  <div :class="activeTab == 'all' ? ' tab-options' : ''" @click.prevent="fetchData('all')"
                    class="mx-2 opt">
                    All
                  </div>
                  |
                  <div :class="activeTab == 'not-generated' ? ' tab-options' : ''"
                    @click.prevent="fetchData('not-generated')" class="mx-2 opt">
                    Plan Not Generated
                  </div>
                  |
                  <div :class="activeTab == 'generated' ? ' tab-options' : ''" @click.prevent="fetchData('generated')"
                    class="mx-2 opt">
                    Plan Generated
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table striped bordered :items="tableData.data" :fields="fields" :sort-by.sync="sortBy" :per-page="0"
                :current-page="currentPage" :sort-desc.sync="sortDesc" :filter-included-fields="filterOn"
                @filtered="onFiltered" responsive="sm" class="table-bordered table-hover" :key="key">
                <template v-if="can('edit-poshiq-diet-plan')" v-slot:cell(edit)="row">
                  <div :class="{ 'disabled-link': row.item.status !== 'created' }">
                    <router-link :to="{
                      name: 'edit-poshiq-diet-plan',
                      params: { id: row.item.id },
                    }">
                      <i class="fa fa-edit edit-i"></i>
                    </router-link>
                  </div>
                </template>
                <!-- <template can="'update-poshiq-diet-plan-status'" v-slot:cell(gen_plan_status)="row">
                    <div class="text">
                        <b-button
                        v-if="row.item.status === 'processing'"
                        variant="primary"
                        size="md"
                        @click="generatePlanById(row.item)"
                        >
                        {{ loadingId === row.item.id ? 'Generating...' : 'Generate Diet Plan' }}
                        </b-button>
                    </div>
                </template> -->
                <!-- <template can="'update-poshiq-diet-plan-status'" v-slot:cell(gen_plan_status)="row">
                  <div class="text"> -->
                    <!-- Show button only if status = processing -->
                    <!-- <b-button v-if="row.item.status === 'processing'" variant="primary" size="sm"
                      :disabled="loadingId === row.item.id" @click="generatePlanById(row.item)">
                      {{ loadingId === row.item.id ? 'Generating...' : 'Generate Diet Plan' }}
                    </b-button> -->

                    <!-- Optional: Show text after generating -->
                    <!-- <span v-else-if="row.item.status === 'created'">✅ Diet plan generated</span> -->
                    <!-- Show link if diet plan is created and pdf_url exists -->
                    <!-- <div v-else-if="row.item.status == 'created' && row.item.pdf_url">
                      ✅ Diet plan generated
                      <a :href="row.item.pdf_url" target="_blank" rel="noopener noreferrer" class="ml-2 text-primary">
                        View PDF
                      </a>
                    </div>

                    <div v-else-if="row.item.status == 'created' && row.item.file_name">
                      ✅ Diet plan generated
                      <a :href="row.item.file_name" target="_blank" rel="noopener noreferrer" class="ml-2 text-primary">
                        View PDF
                      </a>
                    </div> -->

                    <!-- Optional: fallback if created but no PDF -->
                    <!-- <div v-else-if="row.item.status === 'created' && !row.item.pdf_url">
                      ✅ Diet plan generated (No PDF available)
                    </div>
                  </div>
                  <b-button class="mt-2" size="sm" variant="primary" @click="openModal(row.item.chat)">
                    View Documents
                  </b-button>
                  <b-button class="mt-2 ml-2" size="sm" variant="primary" @click="openChatModal(row.item.chat)">
                    Question and Answer
                  </b-button>
                </template> -->

                <template can="'update-poshiq-diet-plan-status'" v-slot:cell(gen_plan_status)="row">
                  <div class="text">

                    <!-- Show Generate button only if status = processing -->
                    <b-button 
                      v-if="row.item.status === 'processing'" 
                      variant="primary" size="sm"
                      :disabled="loadingId === row.item.id"
                      @click="generatePlanById(row.item)"
                    >
                      {{ loadingId === row.item.id ? 'Generating...' : 'Generate Diet Plan' }}
                    </b-button>

                    <!-- Show Re-Generate button if status = created -->
                    <b-button 
                      v-if="row.item.status === 'created'" 
                      variant="warning" size="sm"
                      :disabled="loadingId === row.item.id"
                      @click="generatePlanById(row.item)"
                      
                    >
                      {{ loadingId === row.item.id ? 'Re-Generating...' : 'Re-Generate Plan' }}
                    </b-button>

                    <!-- PDF Links -->
                    <div v-if="row.item.status === 'created' && (row.item.pdf_url || row.item.file_name)" class="mt-2">
                      ✅ Diet plan generated
                      <a 
                        :href="row.item.pdf_url || row.item.file_name" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        class="ml-2 text-primary"
                      >
                        View PDF
                      </a>
                    </div>

                    <!-- Fallback -->
                    <div v-else-if="row.item.status === 'created' && !row.item.pdf_url">
                      ✅ Diet plan generated (No PDF available)
                    </div>
                  </div>

                  <!-- View Documents button -->
                  <b-button class="mt-2" size="sm" variant="primary" @click="openDocumentsById(row.item.id)">
                    View Documents
                  </b-button>

                  <!-- Question & Answer button -->
                  <b-button class="mt-2 ml-2" size="sm" variant="primary" @click="openQnAById(row.item.id)">
                    Question and Answer
                  </b-button>

                  <b-button class="mt-2 ml-2" size="sm" variant="primary" @click="openEditAnswerById(row.item.id)">
                    Edit Answer
                  </b-button>
                </template>

                <template v-slot:cell(status)="row">
                  <div v-if="row.item.status == 'processing'">
                    <span class="p-1 badge badge-warning">Processing</span>
                  </div>
                  <div v-if="row.item.status == 'created' && row.item.file_name">
                    <span class="p-1 badge badge-success">Created</span>
                  </div>
                </template>
                <template v-can="'update-poshiq-diet-plan-status'" v-slot:cell(is_approved)="row">
                  <b-form-checkbox switch class="mb-1" @change="updateApproveStatus(row.item.id)"
                    :checked="row.item.is_approved == 1 ? true : false" :disabled="row.item.status !== 'created'">
                  </b-form-checkbox>
                </template>
              </b-table>
              <b-modal id="document-modal" title="Documents" size="xl" hide-footer>
                <b-tabs card>

                  <!-- IMAGES TAB -->
                  <b-tab title="Images">
                    <div class="row mt-3">
                      <div 
                        class="col-md-3 col-6 mb-3"
                        v-for="file in imageFiles"
                        :key="file"
                        @click="openFile(file)"
                        style="cursor: pointer;"
                      >
                        <img 
                          :src="file"
                          class="img-thumbnail"
                          style="height: 130px; width: 100%; object-fit: cover;"
                        />
                      </div>

                      <div v-if="imageFiles.length === 0" class="text-center w-100 py-5 text-muted">
                        No Images Found
                      </div>
                    </div>
                  </b-tab>

                  <!-- PDFs TAB -->
                  <b-tab title="PDFs">
                    <div class="row mt-3">
                      <div 
                        class="col-md-3 col-6 mb-3"
                        v-for="file in pdfFiles"
                        :key="file"
                        @click="openFile(file)"
                        style="cursor: pointer;"
                      >
                        <div 
                          class="border rounded d-flex flex-column align-items-center justify-content-center"
                          style="height:130px; background:#f8f9fa;"
                        >
                          <i class="fa fa-file-pdf text-danger" style="font-size:48px;"></i>
                          <small class="mt-2">Open PDF</small>
                        </div>
                      </div>

                      <div v-if="pdfFiles.length === 0" class="text-center w-100 py-5 text-muted">
                        No PDFs Found
                      </div>
                    </div>
                  </b-tab>

                </b-tabs>

              </b-modal>
              <b-modal id="chat-modal" title="Question & Answer" size="lg" hide-footer>
                <div v-if="chatList.length > 0">
                  <div 
                    class="p-3 mb-3 border rounded"
                    v-for="(qa, index) in chatList" 
                    :key="index"
                  >
                    <h6 class="font-weight-bold">
                      Q{{ index + 1 }}. {{ qa.question.question }}
                    </h6>

                    <p class="text-muted ml-3">
                      → {{ formatAnswer(qa.answer) }}
                    </p>
                  </div>
                </div>

                <div v-else class="text-center text-muted py-5">
                  No Question-Answer found
                </div>
              </b-modal>
              <b-modal id="chat-modal-edit" title="Question & Answer" size="lg" hide-footer>

                  <div
                      class="p-3 mb-3 border rounded"
                      :class="{ 'highlight-question': qa.highlight }"
                      v-for="(qa,index) in chatList"
                      :key="qa.id"
                  >

                      <div class="d-flex justify-content-between">
                          <h6>
                              Q{{ index + 1 }}. {{ qa.question.question }}
                          </h6>

                          <b-button
                              v-if="qa.question.type !== 'bmi'"
                              size="sm"
                              variant="primary"
                              @click="qa.editing = !qa.editing"
                          >
                              {{ qa.editing ? 'Cancel' : 'Edit' }}
                          </b-button>
                      </div>

                      <div v-if="!qa.editing">
                          {{ formatAnswer(qa.answer) }}
                      </div>

                      <div v-else>

                          <b-form-input
                              v-if="qa.question.type === 'input'"
                              v-model="qa.answer"
                          ></b-form-input>

                          <b-form-radio-group
                              v-else-if="qa.question.type === 'option'"
                              v-model="qa.answer"
                              :options="parseOptions(qa.question.option)"
                          ></b-form-radio-group>

                          <b-form-checkbox-group
                              v-else-if="qa.question.type === 'multicheck'"
                              v-model="qa.answer"
                              :options="parseOptions(qa.question.option)"
                              @change="limitMealsSelection(qa)"
                          ></b-form-checkbox-group>

                          <div v-else-if="qa.question.type === 'file'">

                              <div class="mb-2">
                                  Current File:
                                  {{ !qa.file || qa.file.length === 0 ? 'No file uploaded' : '' }}
                              </div>

                              <!-- Selected files -->
                              <div class="post_images" v-if="qa.file && qa.file.length">

                                  <div
                                      style="position: relative"
                                      v-for="(file, fileIndex) in qa.file"
                                      :key="fileIndex"
                                  >

                                      <div @click.prevent="removeFile(fileIndex, qa)">
                                          <i class="mdi mdi-close-circle cross"></i>
                                      </div>

                                      <img
                                          v-if="isImage(file)"
                                          :src="getFilePreview(file)"
                                          width="150" height="150"
                                      >

                                      <!-- PDF -->
                                      <div
                                          v-else-if="isPdf(file)"
                                          class="text-center p-3 border"
                                      >
                                          <a
                                              :href="getFilePreview(file)"
                                              target="_blank"
                                          >
                                              <i
                                                  class="mdi mdi-file-pdf text-danger"
                                                  style="font-size:50px"
                                              ></i>

                                              <div class="mt-2">
                                                  {{ getFileName(file) }}
                                              </div>
                                          </a>
                                      </div>

                                  </div>

                              </div>

                              <!-- Select one file at a time -->
                              <b-form-file
                                  v-model="qa.selectedFile"
                                  @input="addFile($event, qa)"
                                  accept="image/*,.pdf"
                              ></b-form-file>

                          </div>

                          <div v-else-if="qa.question.type === 'bmi'">
                            {{ qa.answer }}
                          </div>

                          <b-button
                              v-if="qa.question.type !== 'bmi'"
                              class="mt-2"
                              size="sm"
                              variant="success"
                              :disabled="qa.saving"
                              @click="updateAnswer(qa)"
                          >
                              {{ qa.saving ? 'Saving...' : 'Save' }}
                          </b-button>

                          <b-button v-if="qa.question.type === 'file'"
                                  class="mt-2 ml-2"
                                  size="sm"
                                  variant="secondary"
                                  :disabled="qa.saving"
                                  @click="skipUpload(qa)"
                              >
                                  Skip
                              </b-button>

                      </div>

                  </div>

              </b-modal>
            </div>
            <template v-if="tableData.total_pages > 0">
              <div class="data_paginate mt-2">
                <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" first-number last-number :total-rows="tableData.total"
                      :total-pages="tableData.total_pages" :per-page="tableData.per_page"></b-pagination>
                  </ul>
                </div>
                <div class="form-inline navbar-search">
                  <span class="mr-2">Go to a Particular Paginated Page :</span>
                  <div class="input-group">
                    <b-form-input id="case" v-model="pageNo" placeholder="Enter Page No" class="in-width">
                    </b-form-input>
                    <div class="input-group-append">
                      <button class="btn btn-search" @click="filterPage">
                        <i class="fas fa-search fa-sm"> </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.disabled-link {
  pointer-events: none;
  opacity: 0.5;
}
.highlight-question {
    border: 3px solid #28a745 !important;
    background-color: #e8fff0;
    transition: all .3s ease;
}
</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import DietPlanMixin from "../../../mixins/ModuleJs/poshiq-diet-plan";

export default {
  data() {
    return {
      title: "Poshiq Diet Plan",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "List",
        },
      ],
    };
  },
  mixins: [MixinRequest, DietPlanMixin],
  components: {
    Layout,
    PageHeader,
  },
};
</script>